import React from 'react';
import styles from './MenuItemCard.module.css';
import { MenuItem } from 'models/digitalMap';
import { useCurrencyFormatter } from 'components/Map/useCurrencyFormatter';

interface MenuItemProps {
  item: MenuItem;
  note?: string;
}

export const MenuItemCard: React.FC<MenuItemProps> = ({ item, note }) => {
  const thumbnail = item.media_items.find((mediaItem) => mediaItem.type === 'IMAGE')?.url;

  const currencyFormatter = useCurrencyFormatter();

  return (
    <article className={styles.menuItem}>
      <div className={styles.imageWrapper}>
        {thumbnail ? (
          <img src={thumbnail} alt={item.name} className={styles.itemImage} />
        ) : (
          <div className={styles.noImageBackground}>
            <img
              src="/static/images/map/fork_spoon_white.svg"
              alt="No image"
              className={styles.noImageIcon}
            />
          </div>
        )}
      </div>
      <h3 className={styles.itemName}>{item.name}</h3>
      <div className={styles.priceContainer}>
        <span className={styles.price}>{currencyFormatter.format(item.price)}</span>
      </div>
      {note && <div className={styles.note}>{note}</div>}
    </article>
  );
};
